import styled, { css, keyframes } from 'styled-components';

const blinker = keyframes`
  50% {
    opacity: 0.5;
  }
`;

const getBlinkingText = (blink) => {
  if (blink) {
    return css`
      animation: ${blinker} 0.5s linear infinite;
      -webkit-animation: ${blinker} 0.5s linear infinite;
    `;
  }
  return null;
};

export const RoomContainer = styled.div`
  align-items: center;
  text-align: center;
  /* margin: ; */
  border-style: solid;
  border-color: ${(props) => (props.allRooms ? '#006aa3' : '#ccc')};
  border-width: ${(props) => (props.allRooms ? '10px' : '1px')};
  margin: ${(props) => (props.allRooms ? '5px 15px' : '15px')};
  flex-direction: column;
  display: flex;
  flex-wrap: wrap;
  width: 25%;
`;

export const LaneTitle = styled.h2`
  height: 70px;
  font-size: 0.85rem;
  font-weight: bold;
  background: linear-gradient(#50514f,#9a9c98) ;
  width: calc(100% - 20px);
  padding: 0px 10px;
  margin:0;
  justify-content: center;
  align-items: center;
  vertical-align: center;
  display: flex;
  color: white;
  font-family: Roboto, sans-serif;
`;

export const AudioControl = styled.a`
  &:hover {
    opacity: 0.6;
  }
  border-bottom: 3px white solid;
  width: 100%;
  padding: 15px 0;
  cursor: pointer;
  background: ${(props) => (props.playing ? 'linear-gradient(#0ead69,#3be39a)' : 'linear-gradient(#0077b6,#5bbff5)')};
  ${(props) => props.playing && getBlinkingText(props.blink)}
`;

export const AudioLabel = styled.p`
  text-align: center;
  width: 100%;
  margin: 0 0 10px 0;
  color: white;
`;

export const PlayLiveAudioButton = styled.a`
  &:hover {
    opacity: 0.6;
  }
  cursor: pointer;
  background-color: ${(props) => (props.isLiveAudioPlaying ? 'green' : 'red')};
  background: ${(props) => (props.isLiveAudioPlaying ? 'linear-gradient(#0ead69,#3be39a)' : 'linear-gradient(#00b4d8,#6ee3fa)')};
  width: calc(100% - 30px);
  padding: 15px;
  border-bottom: 3px white solid;
  ${(props) => props.isLiveAudioPlaying && getBlinkingText(props.blink)}
`;

export const PlayPauseMusic = styled.a`
  // background-color: ${(props) => (props.playing ? 'rgb(18, 130, 229)' : 'red')};
  // padding: 10px;
  // text-align: center;
   cursor: pointer;
  // display: flex;
  // color: white;
  // font-weight: bold;
  // width: calc(100% - 20px);
`;
